import { useState } from "react";
import type { Database } from "@/lib/supabase";
import { Badge } from "../ui/badge";
import { getDisplayName, formatLastMessageDate, getContactAvatarUrl } from "@/utils/contactUtils";

type AccountContact = Database['public']['Tables']['account_contacts']['Row']

interface ContactListItemProps {
  contact: AccountContact;
  isSelected: boolean;
  onSelect: () => void;
}

export const ContactListItem = ({ contact, isSelected, onSelect }: ContactListItemProps) => {
  const [isClicking, setIsClicking] = useState(false);
  const [imageError, setImageError] = useState(false);
  const displayName = getDisplayName(contact);
  const lastMessageDate = formatLastMessageDate(contact.last_message_at);
  const avatarUrl = getContactAvatarUrl(contact);

  const handleClick = () => {
    if (isClicking) return;

    setIsClicking(true);
    onSelect();

    setTimeout(() => {
      setIsClicking(false);
    }, 100);
  };

  return (
    <div
      onClick={handleClick}
      className={`p-4 cursor-pointer text-neutral-50 transition-colors border-b border-[#3F3F464D] last:border-b-0 ${
        isSelected ? "bg-neutral-500" : "hover:bg-neutral-600"
      } ${isClicking ? "opacity-70" : ""}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
          <img
            src={imageError ? getContactAvatarUrl({ ...contact, profile_picture: null }) : avatarUrl}
            alt={displayName}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-medium truncate text-sm">{displayName}</h3>
            <span className="text-xs text-neutral-400 flex-shrink-0 ml-2">
              {lastMessageDate}
            </span>
          </div>
          <p className="text-xs text-neutral-400 truncate">
            {contact.is_group ? "Grupo" : "Conversa individual"}
          </p>
          <div className="flex gap-1 mt-2">
            {contact.is_group && (
              <Badge variant="default2" className="text-xs">
                Grupo
              </Badge>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};